import styled from "styled-components"

interface IBoxProps {
  children: React.ReactNode
  fullwidth?: boolean
  alignItems?: "flex-start" | "center" | "flex-end"
  justifyContent?: "flex-start" | "center" | "flex-end"
  gapInRem?: number
  flexDirection?: "row" | "column"
  flexWrap?: "wrap"
}

const StyledBox = styled.div<IBoxProps>`
  display: flex;
  align-items: ${(props) => props.alignItems || "center"};
  flex-direction: ${(props) => props.flexDirection || "row"};
  flex-wrap: ${(props) => props.flexWrap || "nowrap"};
  ${(props) => props.gapInRem && `gap: ${props.gapInRem}rem;`}
  justify-content:${(props) => props.justifyContent || "center"};
  ${(props) => props.fullwidth && `width: 100%;`}
`

const Box = (props: IBoxProps) => {
  const { children, ...rest } = props
  return <StyledBox {...rest}>{children}</StyledBox>
}

export { Box }
